/*
Aditya  9/21/2022   2700799562   Fixed GAL-190 Global Fieldlist bug
Sohel   10/03/2022  2700768219   Category look up Changes, Fixed GAL-343,336 and Download Configuration Payload Changes
ashraf  10/04/2022  2700799562   fixed usage Api payload for download in usage tab
Sohel   10/06/2022  2700799562   Fixed based on Framework record not sorted issue
Sohel   10/11/2022  2700799562   Download Configuration Usage Payload Changes
Sohel   10/14/2022  2700753823   Added Code Comments Changes
Sohel   10/14/2022  2700753823   Added Code Comments
Suresh  10/17/2022  2700799562   Design Enhancements in global Field Group, List.
saikrishna 11/03/2022 2700799562 changed the paginationOptions
Sohel 11/05/2022 2700799562 rename download configurations
Gummala Prakash 11/29/2022 2700799562 Removed Margin Spacing.
Lalitha  12/07/2022 2700799562  Rename Global Field List to Field List
Poornima 12/08/2022 2700799562  changed usage title
Ashraf 01/02/2022 2700799562 renamed usage header title
Ashraf 01/11/2022 2700799562 conditional renders for audit list
suresh peddavoora 02/24/2023 2700799562 New UI changes


*/
import React, {useEffect, useState, createRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import capitalize from '../../../../../util/Capitalize';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../../components/TableIcons';
import {resetUsageData} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {Button, TablePagination} from '@material-ui/core';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {ArrowBack} from '@material-ui/icons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {modulesText} from '../../../../../util/Content';

export default function UsageFieldList({setTabValue, fieldListRowData, setUsageState, AuditFieldList}) {
  const [search, setSearch] = useState('');
  const tableRef = createRef();
  const {isLoading, successMsg, errorMsg, fieldListDataUsage} = useSelector(
    ({addFieldList}) => addFieldList,
  );
  const printusage = useSelector(({printusage}) => printusage);
  const dispatch = useDispatch();

  // print error or success toast message reset after 3sec.(2700799562)
  useEffect(() => {
    if (printusage.errorMsg || printusage.successMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printusage.errorMsg, printusage.successMsg]);

  // reset Usage Data and reset Usage state(2700799562)
  useEffect(() => {
    return () => {
      setUsageState(false);
      dispatch(resetUsageData());
    };
  }, []);

  const object = fieldListDataUsage?.placeResponse ? fieldListDataUsage?.placeResponse : {};

  const values = [];
  object &&
    Object.entries(object)?.forEach(([key, value]) => {
      value?.codes?.length > 0 &&
        value?.codes?.forEach((el, i) => {
          values.push({
            frameWork: key,
            codes: el,
            description: value?.description?.[i] ?? '-',
          });
        });
    });

  const columns = [
    {
      title: modulesText,
      field: 'frameWork',
      render: (rowData) => {
        return rowData?.frameWork ? capitalize(rowData?.frameWork) : '-';
      },
    },
    {
      title: 'Code',
      field: 'codes',
      customFilterAndSearch: (term, rowData) => rowData?.codes?.toString()?.indexOf(term) > -1,
      render: (rowData) => {
        return rowData?.codes ? rowData?.codes : '-';
      },
    },
    {
      title: 'Description',
      field: 'description',
      render: (rowData) => {
        return rowData?.description ? rowData?.description : '-';
      },
    },
  ];
  return (
    // Added Search field List Button for Routing (2700799562)
    <div>
      <div className="button-table-spacing-mb justify-content-start new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn mx-1`}
          onClick={() => {
            setTabValue(0);
          }}
        >
          <ArrowBack className="mr-2" />
          {`Search ${AuditFieldList ? 'Audit' : ''} Field List`}
        </Button>
      </div>
      <div className="custom-table custom-toolbar-icons global-field-table new-standard-textfields">
        <GuiTable
          title={`${fieldListRowData?.fieldListCode} - ${fieldListRowData?.fieldListDesc} ${AuditFieldList ?
            'Audit' : ''} Field List has been used in the following places.`}
          columns={columns}
          icons={tableIcons}
          data={values}
          tableRef={tableRef}
          onSearchChange={() => {
            setSearch(tableRef?.current?.dataManager?.searchText);
          }}
          textAlign="left"
          actions={[]}
          components={{
            Pagination: (props) => (
              // Added Download Configuration Buttons in Table pagination (2700799562)
              <div className="global-field-table-footer ">
                <div className="mt-2">
                  <Button
                    type="button"
                    variant="outlined"
                    className={`mx-1 search-btn`}
                    disabled={fieldListDataUsage.userMetrix === 'No'}
                    onClick={(event) => {
                      dispatch(
                        postPrintUsage({
                          baseCategory: fieldListRowData?.baseCategory ?
                            fieldListRowData?.baseCategory?.split('-')?.[0] :
                            '',
                          code: fieldListRowData?.fieldListCode ?
                            fieldListRowData.fieldListCode :
                            '',
                          description: fieldListRowData?.fieldListDesc ?
                            fieldListRowData?.fieldListDesc :
                            '',
                          displayName: '',
                          fileType: '',
                          recordFormatType: '',
                          returnType: '',
                          sourceType: 'FIELD LIST',
                          search: search,
                          frameworkUsageOrderBy:
                            tableRef?.current?.dataManager?.orderBy === 0 ?
                              'targetType' :
                              tableRef?.current?.dataManager?.orderBy === 1 ?
                                'targetCode' :
                                tableRef?.current?.dataManager?.orderBy === 2 ?
                                  'targetDescription' :
                                  '',
                          frameworkUsageOrderDerection: tableRef?.current?.dataManager
                            ?.orderDirection ?
                            tableRef?.current?.dataManager?.orderDirection :
                            '',
                          fieldListOrderBy: '',
                          fieldListOrderDerection: '',
                        }),
                      );
                    }}
                  >
                    Download Configuration Usage
                  </Button>
                </div>
                <div className="w-50" style={{backgroundColor: 'white', border: '0px'}}>
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                    }}
                  />
                </div>
              </div>
            ),
          }}
          options={{
            paging: true,
            toolbar: true,
            search: false,
            sorting: true,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
              fontSize: '0.938rem',
              padding: '16px',
            },
            pageSize: defaultRows,
            pageSizeOptions: tablePageRows,
          }}
        />
      </div>
      {(isLoading || printusage.isLoading) && <PageLoader />}
      {(errorMsg || printusage.errorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printusage.errorMsg} />
      )}
      {(successMsg || printusage.successMsg) && (
        <SuccessSnackbar successMsg={successMsg || printusage.successMsg} />
      )}
    </div>
  );
}
